var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0833333333333333,0,0,1.0833333333333333,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.75,16.74V10.71A1,1,0,0,0,12.16,9.9L7.25,13.99V10.71A1,1,0,0,0,5.66,9.9l-4.5,3.789a1,1,0,0,0-.41.807V23.24h22.5v-5.5a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.25.879a6.931,6.931,0,0,0-2.995.621C7.825,4.672,4.755.76,4.755.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "21.75 16.74 20.75 4.24 17.75 4.24 16.75 16.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.75,20.74a2,2,0,0,0-4,0v2.5h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.75,20.74a2,2,0,0,0-4,0v2.5h4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.25,
    y1: 19.99,
    x2: 16.25,
    y2: 19.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 19.25,
    y1: 19.99,
    x2: 20.25,
    y2: 19.99
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryIcon);
export default __webpack_public_path__ + "static/media/factoryIcon.3622103db206ac25d8128434900789c8.svg";
export { ForwardRef as ReactComponent };